import * as mutation from "./mutation-types";
import * as action from "./action-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import * as lookupsAction from "@/store/lookups/action-types";
import { deepCopyAxiosException } from "@/store/helpers";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import axios from "axios";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const url = tableHelper.constructUrl("/api/roles", state.listing.paging);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_CRITERIA_DESCRIPTION, tableHelper.getCriteriaInfo(headers));
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.LIST_NEXT_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page + 1 });
    await dispatch(action.LIST);
  },
  async [action.LIST_PREVIOUS_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page - 1 });
    await dispatch(action.LIST);
  },

  async [action.VIEW]({ commit, state }, id) {
    commit(mutation.VIEW_STARTED, id);
    try {
      const url = `/api/roles/${id}`;
      const { data } = await axios.get(url);
      commit(mutation.VIEW_SUCCEEDED, data);
      const index = tableHelper.getIndexOfId(state.listing, state.view.data.id);
      commit(mutation.VIEW_NEXT, tableHelper.getNextRecordInfo(index, state.listing));
      commit(mutation.VIEW_PREVIOUS, tableHelper.getPreviousRecordInfo(index, state.listing));
      return true;
    } catch (e) {
      commit(mutation.VIEW_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.VIEW_REFRESH]({ state, dispatch }, roleId) {
    const needsRefreshed = (!state.view.loaded && !state.view.loading) || state.view.roleId != roleId;
    if (needsRefreshed) {
      await dispatch(action.VIEW, roleId);
    }
  },

  async [action.EDIT_GET]({ commit }, id) {
    commit(mutation.EDIT_GET_STARTED);
    try {
      const url = `/api/roles/${id}`;
      const { data } = await axios.get(url);
      commit(mutation.EDIT_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.EDIT_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EDIT_SAVE]({ commit, state, dispatch }) {
    commit(mutation.EDIT_SAVE_STARTED);
    try {
      let result;
      if (state.edit.isNew) {
        result = await axios.post("/api/roles", state.edit.data);
      } else {
        result = await axios.put(`/api/roles/${state.edit.data.id}`, state.edit.data);
      }
      commit(mutation.EDIT_SAVE_SUCCEEDED, result.data);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(SHOW_NOTIFICATION, `Role ${state.edit.isNew ? "created" : "updated"}.`);
      dispatch(lookupsAction.LOAD_DYNAMIC_LOOKUPS);
      return true;
    } catch (e) {
      commit(mutation.EDIT_SAVE_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EDIT_DELETE]({ commit, dispatch }, id) {
    commit(mutation.EDIT_DELETE_STARTED, id);
    try {
      await axios.delete(`/api/roles/${id}`);
      commit(mutation.STATE_UNLOAD, true);
      commit(mutation.EDIT_DELETE_SUCCEEDED);
      commit(SHOW_NOTIFICATION, "Role deleted.");
      dispatch(lookupsAction.LOAD_DYNAMIC_LOOKUPS);
      return true;
    } catch (e) {
      commit(mutation.EDIT_DELETE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EXPORT]({ commit }) {
    commit(mutation.EXPORT_STARTED);
    try {
      commit(SHOW_NOTIFICATION, "Your export will commence shortly.");
      tableHelper.downloadExportedSpreadsheet("/api/exports/roles");
      commit(mutation.EXPORT_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EXPORT_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
